module.exports = __webpack_public_path__ + "static/Gotham-BlackItalic-8d238e4f481d7d7a194628544039edab.woff";